import React from 'react';
import ReactDOM from 'react-dom/client';
import { QuestionAnswerAccordion, type QuestionList } from './QuestionAnswerAccordion';

const questionAnswerData = JSON.parse(document.getElementById('question-answer-data')?.textContent || '[]') as QuestionList[];

const root = ReactDOM.createRoot(document.getElementById('questionAnswerAccordion')!);
root.render(
  <React.StrictMode>
    <QuestionAnswerAccordion questionLists={questionAnswerData} />
  </React.StrictMode>,
);
